import { ControlledSelect } from "@dune/ui";
import { useFormContext } from "react-hook-form";
import { useGetSyndicSocieties } from "../../api/queries/societies.queries";
import { AddOrUpdateContactFormModeProps } from "./ContactForm";
import { ContactFormData } from "./useAddContactForm";

export const SyndicContactForm = ({
	mode,
}: AddOrUpdateContactFormModeProps) => {
	const formMethods = useFormContext<ContactFormData>();
	const {
		control,
		formState: { errors },
	} = formMethods;

	const { data: syndicSocieties } = useGetSyndicSocieties("");

	return (
		<>
			<ControlledSelect
				control={control}
				name="syndicSocietyId"
				label="Société"
				options={syndicSocieties?.map((syndicSociety) => ({
					label: syndicSociety.denomination,
					value: syndicSociety.id,
				}))}
				placeholder="Sélectionner"
				error={errors.syndicSocietyId?.message}
				required
				disabled={mode === "update"}
			/>
		</>
	);
};
